import {useTranslation} from "react-i18next";

export const AccommodationCategory = () => {
  const {t} = useTranslation();

  return [
    {id: "BASIC", name: t('request.basic')},
    {id: "CLASSIC", name: t('request.classic')},
    {id: "COMFORT", name: t('request.comfort')}
  ];
}
